/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function() {
  $('.commonslider').not('.slick-initialized').slick({
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 600,
    infinite: false,
    responsive: [{
        breakpoint: 1400,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true

        }
      },
      {
          breakpoint: 1024,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 2,
              arrows: true

          }
      },
      {
          breakpoint: 650,
          settings: {
              centerMode: true,
              centerPadding: '0%',
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true
          }
      }
    ]
  });

  // Get the current slide
  var currentSlide = $('.commonslider').slick('slickCurrentSlide');

  // Add a class to identify that the user is seeing the first slide
  $('.commonslider').addClass('first-slide-is-active');

  // Change or add that class when there is slider movement
  $('.commonslider').on('afterChange', function(event, slick, currentSlide) {
      if (currentSlide === 0) {
          // Add the class back if back in the first slide
          $('.commonslider').addClass('first-slide-is-active');
      } else {
          // Remove the class
          $('.commonslider').removeClass('first-slide-is-active');
      }
  });

  // Theme-editor previews must display purchasing controls without a region selection.
  if (!window.Shopify?.designMode && (localStorage.getItem("show_ecom") === null || localStorage.getItem("show_ecom") === "")) {
    $('body').append("<style>price-list.price-list, div[data-block-type='quantity-selector'], div[data-block-type='buy-buttons'], a[aria-controls='cart-drawer'] {display:none!important}</style>");

  }
});

(function(){
  function getCookieMain(cName) {
      const name = cName + "=";
      const cDecoded = decodeURIComponent(document.cookie); //to be careful
      const cArr = cDecoded .split('; ');
      let res;
      cArr.forEach(val => {
          if (val.indexOf(name) === 0) res = val.substring(name.length);
      })
    
      return res;
}
  const isCookiePresentMain = getCookieMain("show_launch_popup");
  const popupSection = document.querySelector(".shopify-section--launch-popup");
  if (popupSection) {
    if (!isCookiePresentMain) {
    
      popupSection.classList.remove("fade-out");
      // document.querySelector(".shopify-section--launch-popup").style.display = "block";
    }
    else {

      popupSection.classList.add("fade-out");
      // document.querySelector(".shopify-section--launch-popup").style.display = "none";
    }
  }   
})();

document.querySelectorAll('.subscribe_btn').forEach(function(element) {
  element.addEventListener('click', function() {
    if (document.querySelectorAll('.successPopup').length > 0) {
      document.querySelector('.NewsletterPopup').classList.remove('successPopup');
      document.querySelector('.info_title').style.display = 'none';
      document.querySelector('.info_content').style.display = 'none';
      document.querySelector('.cmApp_signupFormWrapper').style.display = 'block';
    }
    document.querySelector('.NewsletterPopup').setAttribute('aria-hidden', 'false');
    document.querySelector('.Custom_popup-wrapper').classList.add('popup-active');
  });
});

document.querySelectorAll('.NewsletterPopup__Close').forEach(function(element) {
  element.addEventListener('click', function() {
    document.querySelector('.Custom_popup-wrapper').classList.remove('popup-active');
    document.querySelector('.NewsletterPopup').setAttribute('aria-hidden', 'true');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll to the next section when the arrow is clicked
  var scrollDownArrow = document.querySelector('.scroll-down-arrow');
  if(scrollDownArrow){
    scrollDownArrow.addEventListener('click', function(event) {
      event.preventDefault();
      var nextSection = scrollDownArrow.closest('.shopify-section--collection-banner').nextElementSibling;
      if (nextSection.classList.contains('shopify-section--main-collection')) {
        var topOffset = nextSection.getBoundingClientRect().top + window.pageYOffset;
        smoothScrollTo(topOffset, 1000); // Change 1000 to adjust the scrolling speed (in milliseconds)
      }
    });
    }

  // Smooth scroll function
  function smoothScrollTo(to, duration) {
    var start = window.pageYOffset;
    var change = to - start;
    var currentTime = 0;
    var increment = 20;

    function animateScroll() {
      currentTime += increment;
      var val = Math.easeInOutQuad(currentTime, start, change, duration);
      window.scrollTo(0, val);
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll);
      }
    }
    animateScroll();
  }

  // Easing function for smooth scrolling
  Math.easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };
});

/*const productInfoBlockItem = document.querySelector('.product-info__block-item');
 console.log(productInfoBlockItem.childElementCount);
// Check if the element contains only an <hr> tag
if (productInfoBlockItem && productInfoBlockItem.childElementCount === 1) {
  console.log("in if");
  console.log(productInfoBlockItem);
  console.log(productInfoBlockItem.childElementCount);
  const hrElement = productInfoBlockItem.firstElementChild;
  console.log(hrElement);
  if (hrElement.tagName === 'hr') {
      productInfoBlockItem.style.display = 'none';
  } 
}*/
let globeIcon = document.querySelector(".js-launch-popup")

if(globeIcon){
  globeIcon.addEventListener("click",function(event){
    document.querySelector("#launch-popup").classList.add("custom-launch-popup");
    document.querySelector("#launch-popup").style.display ='block';
    document.body.classList.add('lock');
  });
}

let footerGlobeText = document.querySelector(".cookie_value")
if(footerGlobeText){
  footerGlobeText.addEventListener("click",function(event){
    document.querySelector("#launch-popup").classList.add("custom-launch-popup");
    document.querySelector("#launch-popup").style.display ='block';
    document.body.classList.add('lock');
  });
}
let footerGlobeIcon = document.querySelector(".js-launch-popup-footer")
if(footerGlobeIcon){
  footerGlobeIcon.addEventListener("click",function(event){
    document.querySelector("#launch-popup").classList.add("custom-launch-popup");
    document.querySelector("#launch-popup").style.display ='block';
    document.body.classList.add('lock');
  });
}
let button = document.querySelector(".js-close-popup");
if(button){
  button.addEventListener("click",function(close){
    document.querySelector("#launch-popup").classList.remove("custom-launch-popup")
    document.querySelector("#launch-popup").style.display ='none';
    document.body.classList.remove('lock');
  });
}
document.addEventListener("click",function(event){
  // console.log(event.target)
  if(event.target == document.querySelector("#launch-popup") ){
    
    document.querySelector("#launch-popup").classList.remove("custom-launch-popup")
    document.querySelector("#launch-popup").style.display ='none';
    document.body.classList.remove('lock');
  }
});

let button1 = document.querySelector(".launch-popup-wrapper");
if(button1){
  //console.log("click");
  button1.addEventListener("click",function(close){
    document.querySelector("#launch-popup").classList.remove("custom-launch-popup")
    document.querySelector("#launch-popup").style.display ='none';
    document.body.classList.remove('lock');
  });
}

let regionSelect = document.querySelector(".js-region-options");
let languageSelect = document.querySelector(".js-language-options");
let launchButton = document.querySelector(".js-submit-buuton");

if(languageSelect  && document.querySelector("#launch-popup") ){
  languageSelect.addEventListener("change",_languageOptionChange.bind(this),false);
  function _languageOptionChange(selectValue){
    let value = selectValue.target.value;
    console.log(value);
    if(value == "french" ){
      const langSelect = document.querySelector(".js-language-options");
      langSelect.value = 'french'; 
    } else if(value == "english"){
      let langSelect = document.querySelector(".js-language-options");//js-landing-language-options
      langSelect.value = 'english'; 
    }
    
  }
}
if(regionSelect && document.querySelector("#launch-popup")){
  regionSelect.addEventListener("change",_regionOptionChange.bind(this),false);
  launchButton.addEventListener("click",_redirectUrl.bind(this),false);
  function _regionOptionChange(selectValue){
 
    let value = selectValue.target.value;
    if(value == "uk"){
        let langSelect = document.querySelector(".js-landing-language-options");
        document.querySelector(".lang_div_popup").style.display = "none";
        //document.querySelector(".js-language-options").querySelectorAll("option").forEach((option) => {
        //if(option.getAttribute("value") == "french"){
          //option.style.display ="none"
        //}        
      //});
    } else if(value == "global"){
      let langSelect = document.querySelector(".js-landing-language-options");
        document.querySelector(".lang_div_popup").style.display = "block";
        
    }else{
       // document.querySelector(".lang_div_popup").style.display = "block"
      /*document.querySelector(".js-language-options").querySelectorAll("option").forEach((option) => {
        if(option.getAttribute("value") == "french"){
          option.removeAttribute("style");
        }else{
           option.removeAttribute("style");
        }        
      });*/
    }
    
}
  
  function setCookie(cName, cValue, expDays) {
        let date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}
   /* function _redirectUrl(event) {
    
    const launchTo = event.target.closest(".LaunchPopup__Content-wrapper").querySelector(".js-region-options").value;
    const langTo = event.target.closest(".LaunchPopup__Content-wrapper").querySelector(".js-language-options").value;
    let redirectionURL = false;
        switch (launchTo) {
           
            case "global":
                switch (langTo) {
                    case 'english': 
                    setTimeout(() => {
                        document.querySelector("#launch-popup").classList.remove("custom-launch-popup")
                        document.querySelector("#launch-popup").style.display ='none';
                        document.body.classList.remove("lock");
                      }, 800);
                    setCookie(`show_launch_popup`, `global`, 30);
                    document.querySelector(".cookie_value").innerText = getCookie("show_launch_popup");
                     redirectionURL = "https://saphir.com"; 
                    break;
                    
                    case 'french': 
                     
                      setTimeout(() => {
                        document.querySelector("#launch-popup").classList.remove("custom-launch-popup")
                        document.querySelector("#launch-popup").style.display ='none';
                        document.body.classList.remove("lock");
                      }, 800);  
                    setCookie(`show_launch_popup`, `global`, 30);
                    document.querySelector(".cookie_value").innerText = getCookie("show_launch_popup");
                     redirectionURL = "https://saphir.com/fr"; 
                    break;
                }
            break;
            case "uk":
              setTimeout(() => {
                  document.querySelector("#launch-popup").classList.remove("custom-launch-popup")
                  document.querySelector("#launch-popup").style.display ='none';
                  document.body.classList.remove("lock");
                }, 800);
              redirectionURL = "https://uk.saphir.com/"; 
              break;
            
        case "global":{

        
              setTimeout(() => {
                document.querySelector("#launch-popup").classList.remove("custom-launch-popup")
                document.querySelector("#launch-popup").style.display ='none';
                document.body.classList.remove("lock");
              }, 800);
            
                // document.querySelector("body").classList.remove("lock");
                // setCookie(`show_launch_popup`, `global-${langTo}`,30);
                setCookie(`show_launch_popup`, `global`, 30);
               document.querySelector(".cookie_value").innerText = getCookie("show_launch_popup");
              
            // window.location.href = "https://saphir.com/";
              //setCookie("show_launch_popup", true);
          }
          break;
        case "uk":
            setTimeout(() => {
                document.querySelector("#launch-popup").classList.remove("custom-launch-popup")
                document.querySelector("#launch-popup").style.display ='none';
                document.body.classList.remove("lock");
              }, 800);
           
              // document.querySelector("body").classList.remove("lock");
              // setCookie(`show_launch_popup`, `uk-${langTo}`,30);
              window.location.href = "https://uk.saphir.com/";
          break;
        default:
          const launchError = launchWrapper.querySelector(".launch-error");
          launchError.classList.add("active");
          launchError.innerText = "Please select a region";
          break;
      }
    console.log(document.cookie)
  }*/
  function _redirectUrl(event) {
    const launchTo = event.target.closest(".LaunchPopup__Content-wrapper").querySelector(".js-region-options").value;
    const langTo = event.target.closest(".LaunchPopup__Content-wrapper").querySelector(".js-language-options").value;
//    console.log({launchTo, langTo });
    if(launchTo === 'uk'){
      window.location.href = "https://uk.saphir.com/";
      return;
    }

    if(launchTo && langTo){
      const currentLanguage = window.Shopify.locale;
      const selectedLanguage = langTo.substr(0,2);
     // console.log("in if");
     // console.log(currentLanguage);
     // console.log(selectedLanguage);
      if(currentLanguage === selectedLanguage){
        document.querySelector("#launch-popup").classList.remove("custom-launch-popup")
        document.querySelector("#launch-popup").style.display ='none';
        document.body.classList.remove('lock');
        return;
      } 
      else {
       // console.log("in else");
        const selectedLanguage = langTo.substr(0,2);
        setCookie("show_launch_popup", "Global");
        const resourcePath = (window.themeVariables.page.path);
       // console.log(resourcePath);
       // console.log(selectedLanguage);
        if(selectedLanguage === 'en') {
         // console.log("in if");
          // console.log(resourcePath);
          if (resourcePath.includes("/fr")) {
             // console.log("`/fr/` is found in the resourcePath.");
             // console.log(`Trimmed resourcePath: ${resourcePath.trim()}`);
           // console.log(`${window.themeVariables.page.origin}${resourcePath.replace(/\/fr\//g, "/")}`);
            //console.log(`${window.themeVariables.page.origin}${resourcePath.replace(/\/fr/g, "/")}`);
             window.location.href = `${window.themeVariables.page.origin}${resourcePath.replace(/\/fr/g, "/")}`;

          } else {
              console.log("`/fr/` is not found in the resourcePath.");
          }
          //console.log(`${window.themeVariables.page.origin}${resourcePath.replace(/\/fr\//g, "/")}`);

          //window.location.href = `${window.themeVariables.page.origin}${resourcePath.replace("/fr/", "/")}`;
        } else {
         // console.log("in else");
          // console.log(resourcePath);
          const formattedResourcePath = resourcePath === "/" ? "" : resourcePath;

          window.location.href = `${window.themeVariables.page.origin}/fr${formattedResourcePath}`;
        }
        // selectedLanguage === 'en' ? (window.location.href = 'https://saphir.com') : (window.location.href = 'https://saphir.com/fr');
        return;
      }
    }
    
    displayError("Please select a region");

    // // Hide popup and perform redirection
    // setTimeout(() => {
    //     document.querySelector("#launch-popup").classList.remove("custom-launch-popup");
    //     document.querySelector("#launch-popup").style.display = 'none';
    //     document.body.classList.remove("lock");

    //     if (redirectionURL) {
    //         setCookie(`show_launch_popup`, launchTo, 30);
    //         document.querySelector(".cookie_value").innerText = getCookie("show_launch_popup");
    //         window.location.href = redirectionURL;
    //     }
    // }, 800);
}

function displayError(message) {
    const launchError = document.querySelector(".launch-error");
    launchError.classList.add("active");
    launchError.innerText = message;
}
}
// Open the product review accordion before scrolling; overrides Judge.me's default scroll.
document.addEventListener('click', function (event) {
  const link = event.target.closest('.product-heading-row__reviews[href^="#product-reviews-"]');
  if (!link) return;
  const accordion = document.getElementById(link.getAttribute('href').slice(1));
  if (!accordion) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (typeof accordion.toggle === 'function') {
    accordion.toggle(true, false);
  } else {
    accordion.open = true;
    accordion.setAttribute('aria-expanded', 'true');
  }
  const summary = accordion.querySelector('summary');
  if (summary) summary.focus({ preventScroll: true });
  accordion.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
}, true);

// Localize Judge.me's sample badge only inside the Shopify theme editor.
if (window.Shopify?.designMode) {
  const localizedReviewPreviews = new WeakSet();
  const localizeReviewPreviews = function () {
    document.querySelectorAll('.product-heading-row__reviews').forEach(function (badge) {
      if (localizedReviewPreviews.has(badge)) return;
      localizedReviewPreviews.add(badge);
      const updateLabel = function () {
        badge.querySelectorAll('.jdgm-prev-badge__text').forEach(function (label) {
          const sample = label.textContent.trim().match(/^(\d+)\s+sample reviews?\s*\(only in preview\)$/i);
          if (sample) label.textContent = sample[1] + ' Avis clients';
        });
      };
      new MutationObserver(updateLabel).observe(badge, { childList: true, subtree: true, characterData: true });
      updateLabel();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', localizeReviewPreviews, { once: true });
  } else {
    localizeReviewPreviews();
  }
  document.addEventListener('shopify:section:load', localizeReviewPreviews);
}
